import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/lib/theme";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/lib/auth";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Creative from "@/pages/products/Creative";
import Falcon from "@/pages/products/Falcon";
import Mizan from "@/pages/products/Mizan";
import Sahel from "@/pages/products/Sahel";
import Sufi from "@/pages/products/Sufi";
import Billing from "@/pages/Billing";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Admin from "@/pages/Admin";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/app/creative" element={<ProtectedRoute><Creative /></ProtectedRoute>} />
              <Route path="/app/falcon" element={<ProtectedRoute><Falcon /></ProtectedRoute>} />
              <Route path="/app/mizan" element={<ProtectedRoute><Mizan /></ProtectedRoute>} />
              <Route path="/app/sahel" element={<ProtectedRoute><Sahel /></ProtectedRoute>} />
              <Route path="/app/sufi" element={<ProtectedRoute><Sufi /></ProtectedRoute>} />
              <Route path="/app/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
              <Route path="/app/billing/success" element={<ProtectedRoute><CheckoutSuccess /></ProtectedRoute>} />
              <Route path="/app/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster richColors theme="dark" />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
